<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-form ref="form" lazy-validation v-model="valid">
        <v-card>
          <v-card-title>
            {{ isNew ? 'Nueva' : 'Editar' }} Intervención
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <!-- Work Order -->
                <v-col cols="12">
                  <v-autocomplete
                    label="Orden de trabajo"
                    v-model="item.work_order_id"
                    :items="workOrders"
                    item-text="code"
                    item-value="id"
                    :rules="rules"
                    required
                    outlined
                    clearable
                    @change="getOrder($event)"
                  ></v-autocomplete>
                </v-col>

                <!-- Wind Farm -->
                <v-col cols="12">
                  <v-autocomplete
                    label="Parque"
                    v-model="item.wind_farm_id"
                    :items="windFarms"
                    item-text="name"
                    item-value="id"
                    :disabled="!item.work_order_id || loadingWindFarms"
                    :rules="rules"
                    required
                    outlined
                    clearable
                    :loading="loadingWindFarms"
                  ></v-autocomplete>
                </v-col>

                <!-- Technicians -->
                <v-col cols="12">
                  <v-autocomplete
                    label="Operarios"
                    v-model="item.intervention_users"
                    :items="technicians"
                    :item-text="text"
                    item-value="id"
                    :rules="rulesMultiple"
                    required
                    clearable
                    outlined
                    multiple
                  ></v-autocomplete>
                </v-col>

              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="close()">Cancelar</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="submit()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </div>
</template>

<script>
import { WorkOrdersRepository } from "@/api/Repositories";
import Util from "@/util/index";
import moment from 'moment'

export default {
  props: {
    value: Boolean,
    itemSelected: { type: Object, default: null }
  },
  data: () => ({
    valid: false,
    dialog: false,
    loadingWindFarms: false,
    item: {},
    rules: [ v => !!v || 'El campo es obligatorio' ],
    rulesMultiple: [ v => !!v && v.length > 0 || 'El campo es obligatorio' ],
    windFarms: []
  }),
  watch: {
    value (val) {
      this.dialog = val;
      if (!val) this.resetForm();
    },
    dialog (val) {
      if (!val) this.close()
    },
    itemSelected (val) {
      val ? this.init() : this.resetForm()
    }
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isNew () {
      return this.itemSelected === null;
		},
    workOrders () {
      return this.$store.state.orders.work_orders
    },
    technicians () {
      return this.$store.state.users.all.filter(element => {
        return element.roles.filter(e => e.name === 'Operario').length > 0 && element.isActive === true
      })
    },
  },
  methods: {
    formatDate (date) {
      return date ? moment(date).format('DD-MM-YYYY') : ''
    },
    text (item) {
      return item.lastName2
        ? item.firstName + ' ' + item.lastName1 + ' ' + item.lastName2
        : item.firstName + ' ' + item.lastName1
    },
    close() {
      this.dialog = false
      this.resetForm()
      this.$emit('close')
    },
    async init() {
      this.item = Object.assign({}, this.itemSelected)
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const body = {
          ...this.item,
          state_id: 1
        }
        this.close()
        this.loading = true
        this.$store.dispatch('interventions/create', body)
          .then(response => {
            const data = response.data.data      
            const id = data.id      
            console.log("interventions create -> data", data)
            this.$toast("Intervención creada correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.$router.push({
              name: 'intervention-review-edit',
              params: { id: id }
            })
          })
          .catch(error => {
            var errorToastMessage = "Ha ocurrido un error creando la intervención."
            Util.showErrorToast(this, error, errorToastMessage);
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    getOrder (id) {
      this.windFarms = []
      if (id) {
        this.loadingWindFarms = true
        const body = {
          id: id,
          with: 'windFarms'
        }
        WorkOrdersRepository.get(body)
          .then(response => {
            let tempOrder = response.data.data
            // if (tempOrder.wind_farms) tempOrder.wind_farms = tempOrder.wind_farms.map(r => r.id);
            this.windFarms = tempOrder.wind_farms
          })
          .catch(error => {
            console.log("getOrder -> error", error)
            if (error.response.status === 403 ) {
              this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
                color: "error",
                x: "center",
                y: "top",
                icon: "mdi-information",
                timeout: 0,
                showClose: true,
                closeText: "Cerrar"
              });
              this.$router.push({ name: 'home'})
            } else {
              var errorToastMessage = "Ha ocurrido un error cargando la orden de trabajo."
              Util.showErrorToast(this, error, errorToastMessage);
            }
        })
        .finally(() => {
          this.loadingWindFarms = false
        })
      }
    },
    resetForm() {
      this.item = {}
      if (this.$refs.form) this.$refs.form.reset()
    },
    resetValidation() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    }
  }
};
</script>
